import React, { useEffect } from 'react';
import Logo from '../../img/logo.png';
import '../../scss/v2/v2-base.scss';
import '../../scss/v2/v2-pages.scss';

const HeaderAuth = () => {
  useEffect(() => {
    document.body.classList.add('nb-v2');

    return () => document.body.classList.remove('nb-v2');
  }, []);

  return (
    <header className='header-auth'>
      <img src={Logo} alt="New brain logo" width="1" height="1" />
    </header>
  );
};

export default HeaderAuth;
